module.exports = __webpack_public_path__ + "static/img/IMG_20160925_130515.8065ae07.jpg";